<template>
  <div :class="$style.regressionCode" @touchmove.prevent>
    <div :class="$style.mask"></div>
    <div :class="$style.context">
      <div :class="$style.window">
        <p>您的回归豪礼：</p>
        <div :class="$style.code">
          <span>激活码：{{ code }}</span>
          <Button :class="[$style.copy, 'copyBtn']" :data-clipboard-text="code">复制</Button>
        </div>
        <p>请前往游戏大厅-福利-激活码兑换您的回归豪礼吧，如有任何问题，请及时<span :class="$style.lighter" @click="showCustomer">联系客服</span>处理</p>
        <button :class="$style.close" @click="$emit('close')">确认</button>
      </div>
    </div>
  </div>
</template>

<script>
import Clipboard from 'clipboard';
import { Toast } from "vant";
import { mapActions, mapState } from 'vuex';

export default {
  name: "",
  data() {
    return {
    
    };
  },
  async mounted() {
    this.getCdKey()
    this.copy = new Clipboard('.copyBtn');
    this.copy.on('success', () => {
      Toast('复制成功');
    })
  },
  computed: {
    ...mapState({
      code: state => state.recall.cdKey
    })
  },
  methods: {
    ...mapActions({
      showCustomer: 'recall/showCustomer',
      getCdKey: 'recall/getCdKey'
    }),
    submit() {},
    close() {},
    handleBlur(e) {
      this.active = e;
    },
  },
  components: {
  },
};
</script>

<style lang="scss" module>
.lighter {
  color: #3CC0FF;
}
@mixin border-bottom-1px($left: 0, $width: 100%) {
  position: relative;
  &:before {
    display: block;
    position: absolute;
    left: $left;
    bottom: 1px;
    width: $width;
    border-top: 1px solid #ececec;
    content: " ";
    z-index: 1;
  }
}

.regressionCode {
  position: fixed;
  top: 0;
  left: 0;
  bottom: 0;
  right: 0;
  z-index: 100;
  .mask {
    position: absolute;
    top: 0;
    left: 0;
    bottom: 0;
    right: 0;
    background: rgba(0, 0, 0, 0.65);
  }
  .context {
    position: absolute;
    width: 351px;
    height: 215px; 
    top: 0;
    bottom: 0;
    left: 0;
    right: 0;
    margin: auto;
    color: #9F9F9F;
    .window {
      width: 351px;
      height: 215px;
      background: #ffffff;
      border-radius: 12px;
      box-shadow: 0 2px 12px 0 rgba(0, 0, 0, 0.1);
      padding: 30px;
      > p {
        line-height: 1.2;
      }
      .code {
        width: 100%;
        height: 39px;
        background: #F3F3F3;
        color: #9F9F9F;
        padding: 10px 11px;
        margin: 10px 0;
        display: flex;
        justify-content: space-between;
        align-items: center;
        .copy {
          color: #FFFFFF;
          background: #29B7FE;
          padding: 5px 12px;
          border: none;
          outline: none;
          border-radius: 15px;
          font-size: 13px;
          height: auto;
          line-height: 1;
          &:active {
            &:active {
              -webkit-filter: brightness(110%);
              filter: brightness(110%);
            }
          }
        }
      }
      .close {
        width: 247px;
        height: 43px;
        color: #FFFFFF;
        font-size: 15px;
        border-radius: 43px;
        border: none;
        outline: none;
        background: #3CC0FF;
        display: block;
        margin: auto {
          top: 12px;
        };
        &:active {
          &:active {
            -webkit-filter: brightness(110%);
            filter: brightness(110%);
          }
        }
      }
    }
  }
}
</style>